import lrDrawer from './_src/lrDrawer.vue'

lrDrawer.install = function(Vue) {
  Vue.component(lrDrawer.name, lrDrawer)
}

export default lrDrawer